import React, { useEffect, useState } from 'react';
import MostReadCard from '../components/MostReadCard';
import SectionHeader from '../components/SectionHeader';
import { getMostReadRecommendations } from '../../ai-recommendation/services/MostReadRecommendationService';
import { GetArticleRecommendationsResponse } from '../../ai-recommendation/types/GetArticleRecommendationsResponse';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

const MostReadArticles = () => {
  const [mostReadArticles, setMostReadArticles] = useState<GetArticleRecommendationsResponse[]>([]);

  const excludedPosts = window?.mostReadDatas?.excludedPosts;
  const sectionTitle = window?.mostReadDatas?.sectionTitle;
  const hasTitleLink = window?.mostReadDatas?.hasTitleLink;
  const sectionLinkText = window?.mostReadDatas?.sectionLinkText;
  const sectionUrl = window?.mostReadDatas?.sectionUrl;
  const showIcon = window?.mostReadDatas?.showIcon;
  const iconUrl = window?.mostReadDatas?.iconUrl;
  const linkIcon = window?.mostReadDatas?.linkIcon;
  const hideHeader = window?.mostReadDatas?.hideHeader;
  const isExternal = linkIcon === 'external';
  const quantity = window?.mostReadDatas?.quantity;
  const userId = window.crm_user?.user.id;
  const country = window?.country;

  useEffect(() => {
    const fetchMostReadRecommendations = async () => {
      const fingerprintAgent = await FingerprintJS.load();
      const fingerprintResult = await fingerprintAgent.get();

      const response = await getMostReadRecommendations({
        postNumber: quantity ?? 12,
        excludeIds: excludedPosts,
        period: 'pageviews90',
        userToken: fingerprintResult.visitorId ?? '',
        userId: userId?.toString(),
        country: country?.toUpperCase() as 'HU' | 'SK' | 'CZ',
        isLife: window.contentType === 'life',
      });
      setMostReadArticles(response);
    };

    fetchMostReadRecommendations();
  }, [excludedPosts, userId, quantity, country]);

  return (
    <div className="react-most-read">
      <SectionHeader
        title={sectionTitle}
        linkLabel={sectionLinkText}
        url={sectionUrl}
        hasPreIcon={showIcon}
        isExternal={isExternal}
        iconUrl={iconUrl}
        hasTitleLink={hasTitleLink}
        hideHeader={hideHeader}
      />
      <div className="react-most-read__wrapper">
        {(mostReadArticles ?? []).map((article, index) => (
          <MostReadCard
            index={index}
            key={article.title}
            title={article.title}
            url={article.link}
            category={article.categoryName}
            categoryLink={article.categoryLink}
          />
        ))}
      </div>
    </div>
  );
};

export default MostReadArticles;
